module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_SK-160f32a022a5b7188172891dc9d14e1b.svg";